/*
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { BaseCallback } from './base-callback.js';
/**
 * Represents a callback used to collect KBA-style security questions and answers.
 */
export class KbaCreateCallback extends BaseCallback {
    payload;
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the callback prompt.
     */
    getPrompt() {
        return this.getOutputByName('prompt', '');
    }
    /**
     * Gets the callback's list of pre-defined security questions.
     */
    getPredefinedQuestions() {
        return this.getOutputByName('predefinedQuestions', []);
    }
    /**
     * Gets whether the user can define questions.
     */
    isAllowedUserDefinedQuestions() {
        return this.getOutputByName('allowUserDefinedQuestions', false);
    }
    /**
     * Sets the callback's security question.
     */
    setQuestion(question) {
        this.setValue('question', question);
    }
    /**
     * Sets the callback's security question answer.
     */
    setAnswer(answer) {
        this.setValue('answer', answer);
    }
    setValue(type, value) {
        if (!this.payload.input) {
            throw new Error('KBA payload is missing input');
        }
        const input = this.payload.input.find((x) => x.name.endsWith(type));
        if (!input) {
            throw new Error(`No input has name ending in "${type}"`);
        }
        input.value = value;
    }
}
